<template>
    <http-post-button 
        v-bind="$props" 
        v-on="$listeners" 
        href="/api/savedreports" 
        version="v2" 
        @http4xx="onError">
        {{ $t('postReportButton.saveAndView') }}
    </http-post-button>
</template>

<i18n>
{
    "en": {
        "postReportButton.errorMessage": "There was an error encountered while creating this report. If everything looks right please contact support so we can help you :)",
        "postReportButton.saveAndView": "Save and View"
    }
}
</i18n>

<script>
import { toastError } from '@/components/Common/Toast.vue';
import HttpPostButton from '@/components/Common/HttpPostButton.vue';

export default {
    props: { ...HttpPostButton.props },
    methods: {
        onError() {
            toastError(this.$t('postReportButton.errorMessage'));
        },
    },
};
</script>